const state = {
  BRL: {
    decimal: ',',
    thousands: '.',
    prefix: '',
    suffix: '',
    precision: 2,
    masked: false,
    allowBlank: false,
    max: 999.99,
    min: 0.01
  },
  USD: {
    decimal: '.',
    thousands: ',',
    prefix: '$ ',
    suffix: '',
    precision: 2,
    masked: false,
    allowBlank: false,
    max: 999.99,
    min: 0.01
  },
  THOUSANDS: {
    decimal: ',',
    thousands: '.',
    prefix: '',
    suffix: '',
    precision: 0,
    masked: false,
    allowBlank: false,
    max: 999.99,
    min: 0.01
  },
  M2X2: {
    decimal: ',',
    thousands: '.',
    prefix: '',
    suffix: ' m²',
    precision: 2,
    masked: false,
    allowBlank: false,
    max: 999.99,
    min: 0.01
  },
  M3X3: {
    decimal: ',',
    thousands: '.',
    prefix: '',
    suffix: ' m³',
    precision: 2,
    masked: false,
    allowBlank: false,
    max: 999.99,
    min: 0.01
  }
}

export default {
  namespaced: true,
  root: true,
  state
}
